// extracted by mini-css-extract-plugin
export default {"body":"MainPage_body__ETIn9","grid":"MainPage_grid__7Wl66","button":"MainPage_button__MriSJ","active":"MainPage_active__Y1H5O","category":"MainPage_category__PsFsf"};